export enum ContributionRuleCalculationBase {
AllSalaries,
SpecificSalaries,
Imputed,
}
